export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/delete-56bbec1fdf139276aee258f2648726f4.svg";